module.exports = new __parcel__URL__("error-window.c5b5e8aa.svg").toString();